import React from "react"
import { AuthContextInterface, AuthContextValue, AuthProviderType } from "types/auth"



export const AuthServiceContext = React.createContext<AuthContextValue>({
    useAuthHook: () => {
        return {} as AuthContextInterface
    },
    AuthenticationGuard: () => null,
})

export const AuthServiceProvider: React.FC<{
    service: AuthContextValue & { AuthProviderComponent: AuthProviderType }
    children: React.ReactNode
}> = ({ service, children }) => {
    const { AuthProviderComponent } = service

    return (
        <AuthProviderComponent>
            <AuthServiceContext.Provider value={service}>
                {children}
            </AuthServiceContext.Provider>
        </AuthProviderComponent>
    )
}

